import { Text } from "@/components/ui/text";
import { Rank } from "@components/Rank";
import { Avatar } from "@features/Avatar";
import dayjs from "dayjs";
import { Show } from "solid-js";
import { Box, Flex, Grid } from "styled-system/jsx";

export default function Poster(props: {
  username?: string | null;
  id?: string | null;
  rank?: string | null;
  date?: string | null;
}) {
  return (
    <Show when={props.username && props.id}>
      <Flex
        alignItems='center'
        gap='13px'
        flexWrap='wrap'
        pb='20px'
        borderBottomWidth='1px'
        borderBottomStyle='solid'
        borderBottomColor='var(--colors-editorial-hair)'
      >
        <Box position='relative' flexShrink={0} w='42px' h='42px'>
          <Avatar id={props.id ?? undefined} />
          <Show when={props.rank}>
            <Box
              position='absolute'
              right='-3px'
              bottom='-3px'
              borderRadius='full'
              bg='bg.emphasized'
              boxShadow='0 0 0 1px var(--colors-editorial-hair-strong)'
            >
              <Rank rank={props.rank ?? undefined} dimensions='16px' />
            </Box>
          </Show>
        </Box>
        <Grid gap='2px' minWidth={0}>
          <Text fontSize='14px' fontWeight='700' color='editorialInk' textTransform='capitalize'>
            {props.username}
          </Text>
          <Text fontSize='12px' color='editorialInk3'>
            wrote this · {dayjs(props.date).format('MMMM D, YYYY')}
          </Text>
        </Grid>
      </Flex>
    </Show>
  )
}
